import { NgModule } from '@angular/core';
import { ChooseMailOptionsComponent } from './choose-mail-options.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PdfUploaderModule } from '../../../shared/pdf-uploader/pdf-uploader.module';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

@NgModule({
    imports: [
        SharedModule,
        PdfUploaderModule,
        MatSlideToggleModule,
        MatRadioModule,
    ],
    declarations: [ChooseMailOptionsComponent],
    exports: [ChooseMailOptionsComponent],
})
export class ChooseMailOptionsModule
{
}
